<template>
    <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 48 48">
        <g id="Group_2550" data-name="Group 2550" transform="translate(-302 -612)">
            <circle id="Ellipse_69" data-name="Ellipse 69" cx="24" cy="24" r="24" transform="translate(302 612)"
                    fill="#fff"/>
            <g id="Group_2549" data-name="Group 2549" transform="translate(-0.207 -0.207)">
                <circle id="Ellipse_70" data-name="Ellipse 70" cx="4" cy="4" r="4"
                        transform="translate(322.207 632.207)"/>
                <g id="Ellipse_71" data-name="Ellipse 71" transform="translate(318.207 628.207)" fill="none"
                   stroke="#000" stroke-width="1">
                    <circle cx="8" cy="8" r="8" stroke="none"/>
                    <circle cx="8" cy="8" r="7.5" fill="none"/>
                </g>
                <path id="Path_69889" data-name="Path 69889" d="M0,0H3.055"
                      transform="translate(336.979 636.207) rotate(180)" fill="none" stroke="#000" stroke-width="1"/>
                <path id="Path_69890" data-name="Path 69890" d="M0,0H3.055"
                      transform="translate(318.624 636.207) rotate(180)" fill="none" stroke="#000" stroke-width="1"/>
                <path id="Path_69891" data-name="Path 69891" d="M0,0H3.055"
                      transform="translate(326.274 646.911) rotate(-90)" fill="none" stroke="#000" stroke-width="1"/>
                <path id="Path_69892" data-name="Path 69892" d="M0,0H3.055"
                      transform="translate(326.274 628.557) rotate(-90)" fill="none" stroke="#000" stroke-width="1"/>
            </g>
        </g>
    </svg>
</template>

<script>
    export default {
        name: "IGps",
        props: {
            width: {
                type: String,
                default: '1.5em'
            },
            height: {
                type: String,
                default: '1.5em'
            }
        }
    }
</script>

<style scoped>

</style>
